import { z } from 'zod';
import { isMongoId, withPaginationParams } from '../../helpers';

export const ListFurtherUsersInput = withPaginationParams(
  z.object({
    firmId: z
      .string()
      .refine(isMongoId({ optional: true }))
      .optional(),
    search: z.string().optional(),
  }),
  ['email'],
);
